class ProductFixedTabs extends HTMLElement {
  connectedCallback() {
    const tabTitles = JSON.parse(this.dataset.tabTitles || '[]');
    const tabKeys = JSON.parse(this.dataset.tabKeys || '[]');

    const fixedTabsDom = this.querySelector('.product-fixed-tabs');
    const tabContentDom = fixedTabsDom && fixedTabsDom.querySelector('.product-fixed-tabs-content');
    if (!tabContentDom || !tabContentDom.children.length) return;

    const docEle = document.documentElement;
    const sectionDoms = [];

    const getIsPc = () => {
      const ua = navigator.userAgent;
      const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      return !mobileAgents.some((agent) => ua.indexOf(agent) > -1);
    };

    const showTabs = () => {
      const show = !getIsPc() || docEle.clientWidth <= 767;
      fixedTabsDom.style.display = show ? 'block' : 'none';
      return show;
    };

    Array.from(tabContentDom.children).forEach((child, i) => {
      const tabTitle = tabTitles[i];
      if (!tabTitle) return;
      let sectionDom = docEle.querySelector(`[data-section-title="${tabTitle}"]`);
      if (!sectionDom && tabKeys[i]) {
        sectionDom = docEle.querySelector(`#${tabKeys[i]}`);
      }
      if (sectionDom) {
        if (!sectionDoms.length) child.classList.add('active');
        sectionDoms[i] = sectionDom;
        child.style.display = 'flex';
      }
      child.addEventListener('click', this._handleTabClick(i, sectionDoms, tabContentDom, fixedTabsDom, docEle));
    });

    if (!sectionDoms.length) return;

    this._activeIndex = 0;
    this._lastScrollTop = 0;
    this._onScroll = this._handleScroll.bind(this, fixedTabsDom, tabContentDom, sectionDoms, docEle);
    this._onResize = () => {
      if (showTabs()) {
        window.addEventListener('scroll', this._onScroll);
      } else {
        window.removeEventListener('scroll', this._onScroll);
      }
    };

    this._onScroll();
    window.addEventListener('scroll', this._onScroll);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  }

  _handleTabClick(index, sectionDoms, tabContentDom, fixedTabsDom, docEle) {
    return function () {
      Array.from(tabContentDom.children).forEach((child, i) => {
        child.classList.toggle('active', i === index);
      });
      const sectionDom = sectionDoms[index];
      if (sectionDom) {
        const top = sectionDom.getBoundingClientRect().top - fixedTabsDom.getBoundingClientRect().bottom;
        docEle.scrollTo({ top: docEle.scrollTop + top, behavior: 'smooth' });
      }
    };
  }

  _handleScroll(fixedTabsDom, tabContentDom, sectionDoms, docEle) {
    const scrollTop = docEle.scrollTop;
    const isScrollDown = scrollTop - this._lastScrollTop > 0;
    this._lastScrollTop = scrollTop;

    const pageHeaderDom = docEle.querySelector('.shopify-section--header');
    let pageHeaderBottom = 0;
    let showTabsNow = false;
    if (pageHeaderDom) {
      pageHeaderBottom = pageHeaderDom.getBoundingClientRect().bottom;
      showTabsNow = pageHeaderBottom <= scrollTop;
    }
    fixedTabsDom.style.display = showTabsNow ? 'block' : 'none';

    if (!showTabsNow) return;

    const pageHeight = docEle.clientHeight;
    const fixedBottom = fixedTabsDom.getBoundingClientRect().bottom;
    let newActiveIndex = null;

    sectionDoms.forEach((dom, i) => {
      if (!dom) return;
      const rect = dom.getBoundingClientRect();
      if (rect.bottom <= fixedBottom) return;
      if (rect.top >= pageHeight) return;
      if (rect.top - 100 <= fixedBottom && rect.bottom - 100 >= fixedBottom) {
        newActiveIndex = i;
      }
    });

    if (!isScrollDown && this._activeIndex !== null && newActiveIndex === null) {
      newActiveIndex = Math.max(this._activeIndex - 1, 0);
    } else {
      this._activeIndex = newActiveIndex;
    }

    if (newActiveIndex !== null) {
      Array.from(tabContentDom.children).forEach((child, i) => {
        child.classList.toggle('active', i === newActiveIndex);
      });
    }
  }
}

customElements.define('product-fixed-tabs', ProductFixedTabs);
